import { colors } from '@constants/colors';

export const useStyles = () => {
  return {
    content: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '16px',
      minWidth: 220,
    },
    title: {
      fontSize: 17,
      lineHeight: 1.4,
      color: colors.white,
    },
    uncheckedIcon: {
      fontSize: 20,
      color: colors.white,
      flexShrink: 0,
    },
  };
};
